// 全局定义公共、通用的模块

window.common = {};
(function () {
    let _common = {};
    _common.level = function (pms) {
        let state = [];
        if (pms == 1) {
            state = [
                {id: null, name: '全部'},
                {id: 0, name: 'O：未定义'},
                {id: 1, name: 'S：已签约客户'},
                {id: 2, name: 'A1：介意贵，要纠结斟酌'},
                {id: 3, name: 'A2：后期服务没有安全感'},
                {id: 4, name: 'A3：先筹备、再签约，节奏慢'},
                {id: 5, name: 'B1：有资源、有场地、确定做、对比中（1-2个月）'},
                {id: 6, name: 'B2：无资源但好落地、有分析、担心成本估算（周期3-6个月）'},
                {id: 7, name: 'C：无场地资源、项目规划不清晰、有意向、主动学习了解'},
                {id: 8, name: 'D：有场地资源、无意向/不明确'},
                {id: 9, name: 'E：无条件、意向不明确、初步了解'},
                {id: 10, name: 'F：未接、拒绝、广告、托'}
            ];
        } else if (pms == 2) {
            state = [
                {id: null, name: '请选择', disabled: true},
                {id: 0, name: 'O：未定义'},
                {id: 1, name: 'S：已签约客户'},
                {id: 2, name: 'A1：介意贵，要纠结斟酌'},
                {id: 3, name: 'A2：后期服务没有安全感'},
                {id: 4, name: 'A3：先筹备、再签约，节奏慢'},
                {id: 5, name: 'B1：有资源、有场地、确定做、对比中（1-2个月）'},
                {id: 6, name: 'B2：无资源但好落地、有分析、担心成本估算（周期3-6个月）'},
                {id: 7, name: 'C：无场地资源、项目规划不清晰、有意向、主动学习了解'},
                {id: 8, name: 'D：有场地资源、无意向/不明确'},
                {id: 9, name: 'E：无条件、意向不明确、初步了解'},
                {id: 10, name: 'F：未接、拒绝、广告、托'}
            ];
        } else if (pms == 3) {
            state = [
                {id: 0, name: '请选择', disabled: true},
                {id: 2, name: 'A1：介意贵，要纠结斟酌'},
                {id: 3, name: 'A2：后期服务没有安全感'},
                {id: 4, name: 'A3：先筹备、再签约，节奏慢'},
                {id: 5, name: 'B1：有资源、有场地、确定做、对比中（1-2个月）'},
                {id: 6, name: 'B2：无资源但好落地、有分析、担心成本估算（周期3-6个月）'},
                {id: 7, name: 'C：无场地资源、项目规划不清晰、有意向、主动学习了解'},
                {id: 8, name: 'D：有场地资源、无意向/不明确'},
                {id: 9, name: 'E：无条件、意向不明确、初步了解'},
                {id: 10, name: 'F：未接、拒绝、广告、托'}
            ];
        }
        return state;
    };
    common = _common;
}).call(this);
export default common;



// WEBPACK FOOTER //
// ./src/js/common.js